import { useCallback, useDeferredValue, useMemo } from "react";
import {
  useAuthState,
  useOptionalUser,
  authSetCurrentEmployeeId,
} from "./State";
import { graphql, useMutation } from "react-relay";
import { usePersistedEmployeeIdRegisterMutation } from "./__generated__/usePersistedEmployeeIdRegisterMutation.graphql";

export function usePersistedEmployeeId() {
  const [register] = useMutation<usePersistedEmployeeIdRegisterMutation>(
    graphql`
      mutation usePersistedEmployeeIdRegisterMutation($employeeId: ID!) {
        storeViewer(employeeId: $employeeId) {
          registerActivity(type: SESSION_STARTED) {
            __typename
          }
        }
      }
    `
  );
  const [, dispatch] = useAuthState();
  const usr = useOptionalUser();

  const st = useCallback(
    (id: string | undefined | null) => {
      if (id) {
        register({ variables: { employeeId: id } });
      }
      return dispatch(authSetCurrentEmployeeId(id));
    },
    [dispatch, register]
  );

  const deffered = useDeferredValue(usr?.currentEmployeeId);
  const f = useMemo(
    () => ({
      currentEmployeeId: deffered,
      setCurrentEmployeeId: st,
    }),
    [deffered, st]
  );
  return f;
}
